import { StepObjectVisibility, TimelineStep } from '../types/timeline.js';

export interface BundledTimelineState {
  steps: TimelineStep[];
  visibilityAssignments: StepObjectVisibility[];
  lastFrame: number;
}

function cloneTimelineSteps(steps: TimelineStep[]): TimelineStep[] {
  return steps.map((step) => ({
    ...step,
    camera: step.camera
      ? {
          position: [...step.camera.position] as [number, number, number],
          target: [...step.camera.target] as [number, number, number],
        }
      : undefined,
    animation: step.animation ? { ...step.animation } : undefined,
  }));
}

function cloneVisibilityAssignments(assignments: StepObjectVisibility[]): StepObjectVisibility[] {
  return assignments.map((assignment) => ({ ...assignment }));
}

function buildEqualTimelineSteps(
  prefix: string,
  totalFrames: number,
  totalSteps: number,
): TimelineStep[] {
  if (totalSteps <= 0) return [];

  const frameEdges = Array.from({ length: totalSteps + 1 }, (_, index) =>
    Math.round((index * totalFrames) / totalSteps),
  );

  return Array.from({ length: totalSteps }, (_, index) => ({
    id: `${prefix}-step-${index + 1}`,
    order: index,
    name: `Step ${String(index + 1).padStart(2, '0')}`,
    stepText: `Playback test step ${index + 1}`,
    startFrame: frameEdges[index] ?? 0,
    endFrame: frameEdges[index + 1] ?? totalFrames,
  }));
}

const BUNDLED_TIMELINE_PRESETS: Record<string, BundledTimelineState> = {
  'custom:pergola': {
    steps: buildEqualTimelineSteps('pergola', 1781, 10),
    visibilityAssignments: [],
    lastFrame: 0,
  },
};

export function loadBundledTimelineState(modelId: string): BundledTimelineState | null {
  const preset = BUNDLED_TIMELINE_PRESETS[modelId];
  if (!preset) return null;

  return {
    steps: cloneTimelineSteps(preset.steps),
    visibilityAssignments: cloneVisibilityAssignments(preset.visibilityAssignments ?? []),
    lastFrame: preset.lastFrame,
  };
}
